import { mapToAssistanceServiceProduct } from './assistance-service';

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type XProductHeader = { 'X-Product': string } | {};

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type XChannelIdHeader = { 'X-Channel-Id': 'editor' } | {};

/**
 * Only send the X-Product header if the request is to assistance-service
 * Exported for testing purposes
 */
export function getXProductHeader(product: string): XProductHeader {
	return {
		'X-Product': mapToAssistanceServiceProduct(product),
	};
}

export function getXChannelIdHeader(experienceId?: string): XChannelIdHeader {
	switch (experienceId) {
		case 'ai-mate':
			return { 'X-Channel-Id': 'editor' };
		case 'issue-reformatter':
			return { 'X-Channel-Id': 'issue-reformatter' };
		default:
			return {};
	}
}
